module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"parent_reviews":"上一条评论","more_reviews":{"true":"展开 {0} 条评论","false":"收起 {0} 条评论"}}}')
  delete Component.options._Ctor
}
